import { Dropdown } from "primereact/dropdown";
import React from "react";
import { DatabaseEnvironments } from "../types/db_management_types"; 
import { useState } from 'react';

interface Props {
    selectedEnv: string | null;
    onEnvChange: (env: string) => void;
}

function DatabaseEnvironmentDropdown({selectedEnv,onEnvChange}: Props) {
        
    return (
        <>
            <div className="dropdown-control ">
                <Dropdown
                    value={selectedEnv}
                    options={DatabaseEnvironments}
                    placeholder="Select an Environment"
                    onChange={(e) => onEnvChange(e.value)}
               />
      </div>
      </>
  );
}

export default DatabaseEnvironmentDropdown;